module.exports = __webpack_public_path__ + "img/quiz.3a9f605c.png";